import { Injectable } from '@angular/core';

import * as cardValidator from 'card-validator';

@Injectable()
export class CreditCardService {
  public static isValidCard(cardNumber: number) {
    try {
      return cardValidator.number(cardNumber).isValid;
    } catch (error) {
      return false;
    }
  }
}
